<i18n lang="yaml">
ja:
  mainlogo: ロゴ名サービス名
en:
  mainlogo: logo name
</i18n>

<template>
  <footer class="ho-the-footer"></footer>
</template>

<script lang="ts" setup>
/*
 * const props = withDefaults(
 *   defineProps<{
 *   hoge: boolean
 *   fuga?: string
 * }>(),
 * {
 *   hoge: false
 * })
 */
</script>

<style scoped lang="scss">
// .ho-the-footer {}
</style>
